import { type NavigationGuardNext, type RouteLocationNormalized } from 'vue-router'
import { IntegrationNs } from '@shared/types'
import { useIntegrationStore } from '@domains/settings/stores/integration.store'
import { getLocalStorage, removeItemLocalStorage } from '@shared/helpers'
import {toast} from '@shared/ms-components'

export const confirmGoogleDriveAuthenticationResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
): Promise<void> => {
    const payload = {
        authCode: to.query.code,
        state: to.query.state,
        integrationType: IntegrationNs.IntegrationTypeEnums.GOOGLE_DRIVE,
    } as IntegrationNs.ConfirmAuthenticationRequest

    const intStore = useIntegrationStore()

    const callback = getLocalStorage('driveCallback') as { path?: string } | null
    const back = callback?.path
    if (callback) removeItemLocalStorage('driveCallback')

    try {
        await intStore.confirmAuthentication(payload)
        toast.success('Authentication successful')
        next(back ? { path: back, query: { driveSidebar: 'open' } } : { path: '/settings/integrations' })
    } catch {
        toast.error('Authentication unsuccessful')
        next(back ? { path: back } : { path: '/settings/integrations' })
    }
}
